import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferral } from '@/lib/referrals';

export default function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => { captureReferral(search).catch(() => {}); }, [search]);
  return null;
}
